
import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import logo from './logo.svg';
import Trial from "./pages/trial.js";
import trialDone from "./pages/trialDone.js";
import HeaderBar from "./pages/headerBar.js";
import Navbar from "./pages/navbar.js";
import login from "./pages/login.js";
import home from "./pages/home.js";
import myRecord from "./pages/myRecord.js";
import makeClass from "./pages/makeClass.js";
import pickupStudent from "./pages/pickupStudent"
import GetDailyTable from "./pages/getDailyTable"
import './App.css';
// gcloud builds submit --tag asia.gcr.io/good2swim-os3/member
let env = process.env.NODE_ENV;

function App() {
  return (
    <>
    <div className="p-1 container">
       <div id="headerBar" className="fixed-top">
        <HeaderBar />
      </div>
      <Route path="/" exact component={login} />
      <Route path="/trial" exact component={Trial} />
      <Route path="/trialDone" exact component={trialDone} />
      <Route path="/myRecord" exact component={myRecord} />
      <Route path="/makeClass" exact component={makeClass} />
      <Route path="/login" exact component={login} />
      <Route path="/home" exact component={home} />
      <Route path="/GetDailyTable/:getDate" exact component={GetDailyTable}/>
      <Route path="/pickupStudent/:togo" exact component={pickupStudent} />
    </div>
      <div id="footerBar" className="fixed-bottom">
      <Navbar env={env} />
    </div>
    </>
  );
}

export default App;
